export * from './Spinner';
//# sourceMappingURL=index.js.map